import type { MeterResponseDto } from '@/src/api/types/generated-types'
import type { AllLocation, EnrichedLocation } from '@/src/contexts/LocationsContext'
import type { Meter } from '../useMeters.hook'

export const getLocationAndBuildingNames = (
  meter?: Partial<Pick<MeterResponseDto, 'locationTitle' | 'buildingTitle'>>,
  deviceLocation?: AllLocation | EnrichedLocation
): string => {
  if (!meter) return ''

  const { buildingTitle, locationTitle } = meter

  if (!locationTitle) return ''

  const shouldShowBuildingName = buildingTitle && (deviceLocation?.buildings?.length ?? 0) > 2
  return shouldShowBuildingName ? `${locationTitle}, ${buildingTitle}` : locationTitle
}

export const isCubicMeter = (device: Meter) => {
  return device.measurementUnit === 'm3'
}

export const determineSankeyRequestParameters = (
  selectedBuildingIndex: number,
  currentLocation?: AllLocation | EnrichedLocation | null
) => {
  const mode: 'location' | 'building' = selectedBuildingIndex === 0 ? 'location' : 'building'
  const buildingId = mode === 'building' ? currentLocation?.buildings[selectedBuildingIndex].id : undefined
  const locationId = mode === 'location' ? currentLocation?.locationPgId : undefined
  return { mode, buildingId, locationId }
}

export type MeterIdentifiers = {
  meterNumber?: string | null
  maLoId?: string | null
  meLoId?: string | null
}

export const hasMeterIdentifiers = (identifiers: MeterIdentifiers) =>
  getMeterIdentifierSearchValues(identifiers).some(value => !!value?.trim())

export const getMeterIdentifierSearchValues = ({ meterNumber, maLoId, meLoId }: MeterIdentifiers) => [meterNumber, maLoId, meLoId]
